import { render, staticRenderFns } from "./Muy.vue?vue&type=template&id=a652a9f0"
import script from "./Muy.vue?vue&type=script&lang=js"
export * from "./Muy.vue?vue&type=script&lang=js"
import style0 from "./Muy.vue?vue&type=style&index=0&id=a652a9f0&prod&lang=css"
import style1 from "./Muy.vue?vue&type=style&index=1&id=a652a9f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports